const cn = {
  //新项目语言配置,
  searchInformation: '搜索资讯',
  moreInformation: '更多资讯',
  noMore: '暂无更多',
  allComments: '全部评论',
  allReply: '全部回复',
  wantToSay: '你想说点什么？',
  cancle: '取消',
  publish: '发布',
  pleaseEnterComment: '请输入评论',
  peopleSaw: '人看过',
  like: '赞',
  goodArticle: '好文章，需要你的鼓励',
  fromLable: '来自标签',
  noLabel: '暂无标签',
  relatedArticles: '延伸阅读',
  moreArticle: '更多文章',
  everyoneSaying: '大家在说',
  lookAll: '查看全部',
  pieceReply: '条回复',
  noComment: '暂无评论数据',
  moreComment: '更多评论',
  replySomeone: '回复',
  noSearchResults: '暂无搜索结果',
  viewMore: '查看更多',
  searchRecords: '搜索记录',
  clearRecords: '清除记录',
  noSearchHistoryYet: '暂无搜索历史记录',
  noHotNews: '暂无热门文章',
  hotArticle: '热门文章',
  delete: '删除评论',
  deleteCommentOk: '评论删除成功',
  noData: '没有数据',
  requestFail: '请求失败',
  newsDataLoading: '资讯数据加载中',
  newsDataRequestTimeOut: '资讯数据加载超时，点击重试',
  doCommentFail: '评论失败',
  doLikeFail: '点赞失败',
  doCancelLikeFail: '取消点赞失败',
  loading: '加载中...',
  loadFail:'加载失败'
}
export default cn;



// WEBPACK FOOTER //
// ./src/i18n/config/cn.js